import { gql } from 'apollo-angular';
import { dashboardRoleFragment } from '../dashboard-role/dashboard-role.fragments';
import { parentDomainMinimalFragment } from '../parent-domain/parent-domain.fragments';
import { subDomainMinimalFragment } from '../sub-domain/sub-domain.fragments';
import {
  subDomainToWorkspaceConnectionEdgeFragment,
  workspaceViewerCanFragment,
} from '../workspace/workspace.fragments';
import { dashboardFormatItemFragment, dashboardViewerCanFragment } from './dashboard.fragments';

export const dashboardWithDashboardFormatQuery = gql`
  query DashboardWithDashboardFormatQuery($id: ID!) {
    node(id: $id) {
      ... on Dashboard {
        id
        dashboardFormat {
          id
        }
      }
    }
  }
`;

export const DashboardWithWorkspacesQuery = gql`
  query DashboardWithWorkspacesQuery($id: ID!) {
    node(id: $id) {
      ... on Dashboard {
        id
        title
        useAlternativeTitle
        ...DashboardViewerCanFragment

        dashboardFormat {
          ...DashboardFormatItemFragment
        }

        featuredWorkspaceId

        workspaces {
          nodes {
            id
            title
            alternativeTitle
            ...WorkspaceViewerCanFragment
          }
        }
        secondaryWorkspaces {
          nodes {
            id
            title
            alternativeTitle
            dashboard {
              id
              title
            }
          }
        }
      }
    }
  }
  ${dashboardViewerCanFragment}
  ${workspaceViewerCanFragment}
  ${dashboardFormatItemFragment}
`;

export const dashboardWithWorkspacesAndCardCountQuery = gql`
  query DashboardWithWorkspacesAndCardCountQuery($id: ID!) {
    node(id: $id) {
      ... on Dashboard {
        id
        title
        useAlternativeTitle
        ...DashboardViewerCanFragment

        dashboardFormat {
          ...DashboardFormatItemFragment
        }

        dashboardRoles {
          nodes {
            id
          }
        }

        featuredWorkspaceId

        workspaces {
          nodes {
            id
            title
            alternativeTitle
            ...WorkspaceViewerCanFragment
            cardCount
          }
        }
        secondaryWorkspaces {
          nodes {
            id
            title
            alternativeTitle
            cardCount
            dashboard {
              id
              title
            }
          }
        }
      }
    }
  }
  ${dashboardViewerCanFragment}
  ${workspaceViewerCanFragment}
  ${dashboardFormatItemFragment}
`;

export const dashboardsWithViewerCanMinimalQuery = gql`
  query DashboardsWithViewerCanMinimal {
    dashboards {
      edges {
        node {
          id
          ...DashboardViewerCanFragment
        }
      }
    }
  }
  ${dashboardViewerCanFragment}
`;

export const dashboardsQuery = gql`
  query DashboardsQuery {
    dashboards {
      edges {
        node {
          id
          title
          useAlternativeTitle
          ...DashboardViewerCanFragment

          dashboardFormat {
            id
            shortName
          }

          featuredWorkspaceId

          workspaces {
            nodes {
              id
              title
              alternativeTitle
              ...WorkspaceViewerCanFragment

              goalCards {
                activeCardCount
              }

              eventCards {
                activeCardCount
              }
            }
          }
        }
      }
    }
  }
  ${dashboardViewerCanFragment}
  ${workspaceViewerCanFragment}
`;

export const dashboardWithRolesQuery = gql`
  query DashboardWithRolesQuery($id: ID!) {
    node(id: $id) {
      ... on Dashboard {
        id
        title

        viewerCanManage

        dashboardRoles {
          nodes {
            ...DashboardRoleFragment
          }
        }
      }
    }
  }
  ${dashboardRoleFragment}
`;

export const dashboardScopeForRoleModalQuery = gql`
  query DashboardScopeForRoleModalQuery($id: ID!) {
    node(id: $id) {
      ... on Dashboard {
        id
        title
        ...DashboardViewerCanFragment
        workspaces {
          nodes {
            id
            title
            ...WorkspaceViewerCanFragment
          }
        }
      }
    }
  }
  ${dashboardViewerCanFragment}
  ${workspaceViewerCanFragment}
`;

export const dashboardMatrixQuery = gql`
  query DashboardMatrixQuery(
    $id: ID!
    $filterForWorkspaces: WorkspaceFilter
    $filterForSecondaryWorkspaces: WorkspaceFilter
  ) {
    node(id: $id) {
      ... on Dashboard {
        id
        title
        useAlternativeTitle
        ...DashboardViewerCanFragment

        dashboardFormat {
          ...DashboardFormatItemFragment
        }

        featuredWorkspaceId

        parentDomains {
          nodes {
            ...ParentDomainMinimal

            subDomains {
              nodes {
                ...SubDomainMinimal

                secondaryWorkspaces(filter: $filterForSecondaryWorkspaces) {
                  edges {
                    ...SubDomainToWorkspaceConnectionEdge
                  }
                }
                workspaces(filter: $filterForWorkspaces) {
                  edges {
                    ...SubDomainToWorkspaceConnectionEdge
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${subDomainToWorkspaceConnectionEdgeFragment}
  ${parentDomainMinimalFragment}
  ${subDomainMinimalFragment}
  ${dashboardViewerCanFragment}
  ${workspaceViewerCanFragment}
  ${dashboardFormatItemFragment}
`;
